<script>
export default {
  inheritAttrs: false,
  model: {
    event: 'update',
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: '',
    },
    itemText: {
      type: String,
      default: '',
    },
    itemValue: {
      type: String,
      default: '',
    },
  },
}
</script>

<template>
  <v-select
    v-model="$attrs.value"
    :class="$style.textField"
    :items="items"
    :menu-props="{ top: true, maxHeight: 200 }"
    :item-text="itemText"
    :item-value="itemValue"
    dense
    hide-details="auto"
    outlined
    attach
    return-object
    :placeholder="label"
    @change="$emit('update', $attrs.value)"
    v-on="
      $listeners
      // https://vuejs.org/v2/guide/components-custom-events.html#Binding-Native-Events-to-Components
    "
  ></v-select>
</template>

<style lang="scss" module>
@import '@design';

.textField {
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.75px;
}

.textField ::placeholder {
  color: #000 !important;
  opacity: 1;
}
</style>
